import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { finalize, map, take, tap } from "rxjs/operators";
import { EventCategory, iEvent } from "@ui-components/models";

@Injectable({ providedIn: 'root' })
export class EventsService {

    private eventsSubject = new BehaviorSubject<Partial<iEvent>[]>(null);
    events$: Observable<Partial<iEvent>[]> = this.eventsSubject.asObservable();

    private eventsCategoriesSubject = new BehaviorSubject<EventCategory[]>(null);
    eventsCategories$: Observable<EventCategory[]> = this.eventsCategoriesSubject.asObservable();

    private loaderSubject = new BehaviorSubject<boolean>(false);
    showLoader$: Observable<boolean> = this.loaderSubject.asObservable();

    getEventsList$ = this.http.get<Partial<iEvent>[]>('/Events/GetEvents');
    getEventsCategories$ = this.http.get<EventCategory[]>('/Events/GetEventCategories');
    
    constructor(private http: HttpClient) {
        this.loaderSubject.next(true);

        combineLatest([this.getEventsList$, this.getEventsCategories$])
            .pipe(
                tap(([events, categories]) => {
                    this.eventsSubject.next(events);
                    this.eventsCategoriesSubject.next(categories)
                }),
                finalize(() => this.loaderSubject.next(false))
            )
            .subscribe()
    }

    getEventsList(payload: { categoryId?: any; fromDate?: string; search?: string; status?: string; toDate?: string }) {
        const httpOptions = { params: {} };
        const keys = Object.keys(payload);

        for (let key of keys) { Object.assign(httpOptions.params, { [key]: payload[key] }); }

        this.loaderSubject.next(true);

        return this.http.get<Partial<iEvent>[]>('/Events/GetEvents', httpOptions)
            .pipe(
                tap((events: iEvent[]) => events && this.eventsSubject.next(events)),
                finalize(() => this.loaderSubject.next(false))
            )
    }

    getEventById(eventId): Observable<iEvent>{
        return this.http.get<iEvent>(`/Events/GetEventById/${eventId}`)
    }

    repeatType(type: number) {
        if (type === null) { return; }
        switch (type) {
            case 0:
                return 'No repeat';

            case 1:
                return 'Weekly';

            case 2:
                return 'Monthly';

            case 3:
                return 'Yearly';
        }
    }

    isEventExpired(date: Date) {
        if (!date) { return; }
        return new Date() >= new Date(date);
    }

    getEventCategoryName(id: number) {
        let category: EventCategory;
        this.eventsCategories$
            .pipe(
                take(1),
                map(categories => categories && categories.find(c => c.id === id))
            )
            .subscribe((result) => category = result)

        return category.name;
    }


}